import 'animate.css';
import React, { useEffect } from 'react';
import styled from 'styled-components';
import { useDispatch, useSelector } from 'react-redux';
import { Creators as snackbarActions } from '../../domain/useCases/snackbarUseCase';
import iconCancel from '../../assets/icons/cancel.svg';

const Container = styled.div.attrs((props: any) => ({
  backgroundColor: props.backgroundColor
}))`
  z-index: 1000;
  bottom: 1rem;
  // left: 33.3%;
  margin: 0 auto;
  height: 52px;
  padding: 16px 8px;
  border-radius: 8px;
  border: transparent;
  background-color: ${(props: any) => props.backgroundColor};
  box-shadow: 0px 4px 16px -8px #748e98;
  width: 328px;
  opacity: 0;
  // display: none;

  display: flex;
  justify-content: space-between;
  align-items: center;

  p {
    font-weight: normal;
    font-size: 14px;
    line-height: 20px;
    color: #ffffff;
  }

  strong {
    font-weight: bold;
  }

  @media (min-width: 640px) {
    width: 360px;
    margin: 0 auto;
  }
`;

const Button = styled.button.attrs((props: any) => ({
  color: props.color,
  hover: props.hover,
  focus: props.focus
}))`
  border-radius: 4px;
  &:hover {
    background-color: ${(props) => props.hover};
  }

  &:focus,
  &:active {
    background-color: ${(props) => props.focus};
  }

  .animate__animated.animate__fadeInUp {
    --animate-duration: 1s;
  }
`;

const Snackbar = ({ timeout, fieldsSnackbar }: any) => {
  const dispatch = useDispatch();
  const { title1, title2, backgroundColor, hoverCloseColor, focusCloseColor } =
    fieldsSnackbar;

  const { toggleSnackbar } = useSelector((state: any) => state.snackbarBase);

  let TIMER: any;
  const handleClose = () => {
    clearTimeout(TIMER);
    const element = document.querySelector('.snackbarClass');
    element?.classList.remove(`animate__animated`, 'animate__fadeInUp');
    element?.classList.add('animate__animated', 'animate__fadeOutDown');
    setTimeout(() => {
      dispatch(snackbarActions.toggleSnackbarClose());
    }, 1000);
  };

  function handleTimeout() {
    const element = document.querySelector('.snackbarClass');
    element?.classList.remove(`animate__animated`, 'animate__fadeOutDown');
    element?.classList.add('animate__animated', 'animate__fadeInUp');
    TIMER = setTimeout(() => {
      handleClose();
    }, timeout);
  }

  useEffect(() => {
    if (toggleSnackbar) {
      handleTimeout();
    }

    return () => {
      clearTimeout(TIMER);
    };
  }, [toggleSnackbar, TIMER]);

  return (
    <div data-testid="cmp-snackbar">
      <Container
        backgroundColor={fieldsSnackbar?.backgroundColor}
        className="snackbarClass animate__animated"
      >
        <p>
          {' '}
          {title1 && <strong> {title1} </strong>} {title2}
        </p>
        <Button
          color={backgroundColor}
          hover={hoverCloseColor}
          focus={focusCloseColor}
          data-testid="cmp-snackbar-close"
          onClick={handleClose}
        >
          <img src={iconCancel} alt="iconCancel" />
        </Button>
      </Container>
    </div>
  );
};

export default Snackbar;
